<script setup lang="ts">
withDefaults(defineProps<{ height?: string }>(), {
    height: 'h-8',
});
</script>

<template>
    <!--
        The approved artwork is named by the logo colour, not the surface:
        `logo-dark.svg` carries the dark "Launch" lettering for light surfaces,
        `logo-light.svg` carries the light lettering for dark surfaces.
    -->
    <span :class="['inline-flex items-center', height]">
        <img
            src="/logo-dark.svg"
            alt="LaunchStation"
            class="h-full w-auto dark:hidden"
        />
        <img
            src="/logo-light.svg"
            alt="LaunchStation"
            class="hidden h-full w-auto dark:block"
        />
    </span>
</template>
